export const DELETE_CONFIRMATION_DIALOG_LABELS = {
	TITLE_SESSION: 'Delete session?',
	TITLE_TEST: 'Delete test?',
	BODY: 'You cannot undo this action.',
	CANCEL: 'Cancel',
	CONFIRM_SESSION: 'Delete Session',
	CONFIRM_TEST: 'Delete Test',
	TOAST_ERROR: 'Deletion failed. Please retry.'
} as const;
